import { css } from 'styled-components';

// much of this css originated from https://piccalil.li/blog/a-more-modern-css-reset/
// but has been adjusted to suit our needs
export const globalStyleAdjustmentsCss = css`
  /**
  * 1. Change from 'content-box' so that 'width' calculations are unaffected by 'padding' or 'border'
       See: https://css-tricks.com/inheriting-box-sizing-probably-slightly-better-best-practice/
  * 2. Ensure the iOS tap highlight is transparent
  * 3. Prevent font size inflation
  * 4. Fix for 100vh in mobile WebKit
  *    See: https://allthingssmitty.com/2020/05/11/css-fix-for-100vh-in-mobile-webkit/
  */
  html {
    box-sizing: border-box; /* 1 */
    -webkit-tap-highlight-color: rgb(0 0 0 / 0%); /* 2 */
    -moz-text-size-adjust: none; /* 3 */
    -webkit-text-size-adjust: none;
    /* stylelint-disable-next-line plugin/use-baseline */
    text-size-adjust: none;
    height: -webkit-fill-available; /* 4 */
  }

  *,
  *::before,
  *::after {
    box-sizing: inherit; /* 1 */
  }

  /**
  * 1. Without this fonts are too heavy weight in OS X Firefox
  * 2. Design decision
    3. See: https://allthingssmitty.com/2020/05/11/css-fix-for-100vh-in-mobile-webkit/
  */
  body {
    -moz-osx-font-smoothing: grayscale; /* 1 */
    -webkit-font-smoothing: antialiased; /* 2 */
    line-height: 1.5; /* 2 */
    min-height: 100vh; /* 3 */
    min-height: -webkit-fill-available; /* 3 */
  }

  /* Remove default margin in favour of better control in authored CSS */
  body,
  h1,
  h2,
  h3,
  h4,
  p,
  figure,
  blockquote,
  dl,
  dd {
    margin-block-end: 0;
  }

  /* Remove list styles on ul, ol elements with a list role, which suggests default styling will be removed */
  ul[role='list'],
  ol[role='list'] {
    list-style: none;
  }

  /* Set shorter line heights on headings and interactive elements */
  h1,
  h2,
  h3,
  h4,
  button,
  input,
  label {
    line-height: 1.1;
  }

  /* Balance text wrapping on headings */

  /* h1,
  h2,
  h3,
  h4 {
    text-wrap: balance;
  } */

  /* A elements that don't have a class get default styles */
  a:not([class]) {
    text-decoration-skip-ink: auto;
    color: currentcolor;
  }

  /* Make images easier to work with */
  img,
  picture {
    max-width: 100%;
    display: block;
  }

  /* Inherit fonts for inputs and buttons */
  input,
  button,
  textarea,
  select {
    font-family: inherit;
    font-size: inherit;
  }

  /* Anything that has been anchored to should have extra scroll margin */
  &:target {
    scroll-margin-block: 5ex;
  }

  dl {
    margin: 0;
  }

  /* Remove all animations and transitions for people that prefer not to see them */
  @media (prefers-reduced-motion: reduce) {
    html:focus-within {
      scroll-behavior: auto;
    }

    *,
    *::before,
    *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
      scroll-behavior: auto !important;
    }
  }
`;
